import React from 'react';

// This presence of this component on a type enables comments on elements of that type.
const CommentOptions = {
  designer: () => <div />,
  display: () => <div />,
  editor: () => <div />,
};
export default CommentOptions;



// WEBPACK FOOTER //
// ./src/components/types/CommentOptions.js